import React, { Fragment, useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import Countries from "../../components/Countries";
// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { retreive, editAddressBook } from "../../actions/addressbook";

import AccountLeftSidebar from "../../components/AccountLeftSidebar/accountLeftSidebar";
const EditAddressBook = (props) => {
  const [value, setValue] = useState({
    success: false,
    addressBookId: "",
    firstName: "",
    lastName: "",
    company: "",
    country: "",
    address: "",
    city: "",
    postCode: "",
    region: "",
    defaultAddress: 0,
  });

  useEffect(async () => {
    const id = props.location.pathname.split("k/")[1];
    const res = await props.retreive(id);
    if (res) {
      setValue({
        addressBookId: res._id,
        firstName: res.firstName,
        lastName: res.lastName,
        company: res.company,
        country: res.country,
        address: res.address,
        city: res.city,
        postCode: res.postCode,
        region: res.region,
      });
    }
  }, []);

  const onSubmit = async () => {
    const formData = value;
    const res = await props.editAddressBook(formData);

    if (res) {
      setValue({ success: res });
      setTimeout(() => {
        setValue({ success: null });
      }, 4000);
    }
  };

  const {
    firstName,
    lastName,
    company,
    address,
    city,
    country,
    postCode,
    region,
    defaultAddress,
  } = value;
  return (
    <Fragment>
      <div className="update-address-wrapper wrapper-90 max-1600">
        <ul className="breadcrumb">
          <li>
            <Link to={"/"}>
              <i className="fa fa-home" />
            </Link>
          </li>
          <li>
            <Link to="/dashboard"> / Account</Link>
          </li>
          <li>
            <a href=""> / Edit address book</a>
          </li>
        </ul>
        <div className="container-fluid px-0">
          <div className="row">
            <AccountLeftSidebar />
            <div className="col-md-9">
              <header className="update-address-header">
                <h3>Edit an Address</h3>
                {value.success && (
                  <div
                    key={alert.id}
                    variant={alert.alertType}
                    className={`alert alert-success`}
                    role="alert"
                    style={{ marginTop: "3em", marginBottom: "2em" }}
                  >
                    {value.success}
                  </div>
                )}
              </header>
              <form action="#" id="addressForm">
                <div className="address-form-content">
                  <div className="address-inputs">
                    <div className="address-nickname">
                      <label
                        htmlFor="addressnickname"
                        className="address-inputLabel nickname-inp"
                      >
                        <input
                          type="text"
                          className="address-inp"
                          value={firstName}
                          onChange={(e) => {
                            setValue({ firstName: e.target.value });
                          }}
                        />
                        <span className="address-placeholders">First Name</span>
                      </label>
                    </div>
                  </div>
                  <div className="address-inputs">
                    <div className="address-name">
                      <label
                        htmlFor="name"
                        className="address-inputLabel add-name-inp"
                      >
                        <input
                          type="text"
                          className="address-inp"
                          value={lastName}
                          onChange={(e) => {
                            setValue({ lastName: e.target.value });
                          }}
                        />
                        <span className="address-placeholders">Last Name</span>
                      </label>
                    </div>
                  </div>
                  <div className="address-inputs">
                    <div className="address1-2-city">
                      <div className="address1">
                        <label
                          htmlFor="address1"
                          className="address-inputLabel add-name-inp"
                        >
                          <input
                            type="text"
                            className="address-inp"
                            value={address}
                            onChange={(e) => {
                              setValue({ address: e.target.value });
                            }}
                          />
                          <span className="address-placeholders">
                            Address 1
                          </span>
                        </label>
                      </div>

                      <div className="address-cityTown">
                        <label
                          htmlFor="cityTown"
                          className="address-inputLabel add-name-inp"
                        >
                          <input
                            type="text"
                            className="address-inp"
                            value={city}
                            onChange={(e) => {
                              setValue({ city: e.target.value });
                            }}
                          />
                          <span className="address-placeholders">
                            City/Town
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="address-inputs">
                    <div className="address-zip-contry-state">
                      <div className="address-zip">
                        <label
                          htmlFor="zipcode"
                          className="address-inputLabel add-zip"
                        >
                          <input
                            type="text"
                            className="address-inp"
                            value={postCode}
                            onChange={(e) => {
                              setValue({ postCode: e.target.value });
                            }}
                          />
                          <span className="address-placeholders">Zip</span>
                        </label>
                      </div>
                      <div className="checkout-inps">
                        <span className="selectcountry-hint">
                          Select Contry
                        </span>
                        <Countries />
                      </div>
                      <div className="checkout-inps">
                        <label htmlFor="state" className="address-inputLabel">
                          <input
                            type="text"
                            className="address-inp"
                            value={region}
                            onChange={(e) => {
                              setValue({ region: e.target.value });
                            }}
                          />
                          <span className="address-placeholders">State</span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="address-inputs">
                    <div className="address-company-name">
                      <label
                        htmlFor="companyname"
                        className="address-inputLabel"
                      >
                        <input
                          type="text"
                          className="address-inp"
                          value={company}
                          onChange={(e) => {
                            setValue({ company: e.target.value });
                          }}
                        />
                        <span className="address-placeholders">
                          Company Name
                        </span>
                      </label>
                    </div>
                  </div>

                  <div className="address-save-cancel">
                    <div className="add-save-btn">
                      <button
                        type="button"
                        onClick={() => {
                          this.onSubmit();
                        }}
                        className="save-address"
                      >
                        <span>Save</span>
                      </button>
                    </div>

                    <div className="add-cancel-btn">
                      <Link to="/address-book">
                        <button type="button" className="cancel-address">
                          <span>cancel</span>
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

editAddressBook.propTypes = {
  editAddressBook: PropTypes.func.isRequired,
};
retreive.propTypes = {
  retreive: PropTypes.func.isRequired,
};

export default withRouter(
  connect(null, { retreive, editAddressBook })(EditAddressBook)
);
